<template lang='pug'>
Progress(
  v-slot='{ start, stop }'
)
  EventToProp(
    v-slot='{ prop: goal_weight_kg, updateProp: goal_weight_kg_update }'
  )
    EventToProp(
      v-slot='{ prop: current_weight_kg, updateProp: current_weight_kg_update }'
    )
      EventToProp(
        v-slot='{ prop: profile, updateProp: profileUpdate, timestamp }'
      )
        FatSecret(
          @start='start'
          @stop='response => profileUpdate(response?.data?.profile)'
          @error='stop'
          v-slot='{ profileGet }'
        )
          Event(
            @event='profileGet'
          )
        div(
          v-if='profile'
        )
          Event(
            @event='goal_weight_kg_update(profile.goal_weight_kg)'
          )
          Event(
            @event='current_weight_kg_update(profile.last_weight_kg)'
          )
          Event(
            @event='stop'
          )
          v-container
            v-row
              v-col
                v-text-field(
                  v-if='$store.state.weight_type_module.weight_type === "kg"'
                  autocomplete='off'
                  label='Goal Weight'
                  type='number'
                  :value='goal_weight_kg'
                  @input='goal_weight_kg_update'
                )
                v-text-field(
                  v-else
                  autocomplete='off'
                  label='Goal Weight'
                  type='number'
                  :value='roundLb(kgToLb(goal_weight_kg))'
                  @change='lb => goal_weight_kg_update(roundKg(lbToKg(lb)))'
                )
              v-col
                v-radio-group(
                  :value='$store.state.weight_type_module.weight_type'
                  @change='weight_type => $store.commit("weight_type_update", weight_type)'
                  row
                )
                  v-radio(
                    label='lb'
                    value='lb'
                  )
                  v-radio(
                    label='kg'
                    value='kg'
                  )
            v-row
              v-col
                v-text-field(
                  v-if='$store.state.weight_type_module.weight_type === "kg"'
                  autocomplete='off'
                  label='Weight'
                  type='number'
                  :value='current_weight_kg'
                  @input='current_weight_kg_update'
                )
                v-text-field(
                  v-else
                  autocomplete='off'
                  label='Weight'
                  type='number'
                  :value='roundLb(kgToLb(current_weight_kg))'
                  @change='lb => current_weight_kg_update(roundKg(lbToKg(lb)))'
                )
              v-col
                v-radio-group(
                  :value='$store.state.weight_type_module.weight_type'
                  @change='weight_type => $store.commit("weight_type_update", weight_type)'
                  row
                )
                  v-radio(
                    label='lb'
                    value='lb'
                  )
                  v-radio(
                    label='kg'
                    value='kg'
                  )
          FatSecret(
            @start='start'
            @error='stop'
            @stop='onSuccess(current_weight_kg)'
            v-slot='{ weightUpdate }'
          )
            Button(
              :disabled='false'
              @click='weightUpdate({ current_height_cm: 0, current_weight_kg, goal_weight_kg, date })'
            )
</template>

<script>
import { pipe } from 'lodash/fp';

import { stringToNumber } from '../functions/stringToNumber';
import { weightUpdate } from '../functions/weightUpdate';

import Button from './Button.vue';
import Event from './Event.vue';
import EventToProp from './EventToProp.vue';
import FatSecret from './FatSecret.vue';
import Progress from './Progress.vue';

import {
  get_date_int_today,
} from '@thomasphan/helpers-fatsecret';

import weight_type_module from '../store/weight_type';

const kgToLb = function (kg)
{
  return window.Number(kg) * 2.2046226218;
};

const lbToKg = function (lb)
{
  return window.Number(lb) / 2.2046226218;
};

const roundLb = function (num)
{
  return window.Number(num).toFixed(1);
};

const roundKg = function (num)
{
  return window.Number(num).toFixed(2);
};

const onSuccess = function (current_weight_kg)
{
  pipe
  ([
    stringToNumber,
    this.weightUpdate,
  ])
  (current_weight_kg);

  this.$emit('success');
};

const date = get_date_int_today;

const created = function ()
{
  const preserveState = !!this?.$store?.state?.weight_type_module?.weight_type;

  this.$store.registerModule('weight_type_module', weight_type_module, { preserveState });
};

export default
{
  components:
  {
    Button,
    Event,
    EventToProp,
    FatSecret,
    Progress,
  },
  computed:
  {
    date,
  },
  created,
  methods:
  {
    kgToLb,
    lbToKg,
    onSuccess,
    roundKg,
    roundLb,
    weightUpdate,
  },
};
</script>